import ErrorComponent, { ErrorImage } from './ErrorComponent'

export { ErrorImage }
export default ErrorComponent
